/**
 * The API docs admin page's entry: the label the admin page list shows for
 * it, its route, and one sentence on what it is for. The admin routes read
 * its path, and the admin page list (`adminPages.ts`) reads all three. It
 * sits apart from the page so the page list reads it without importing the
 * page.
 */
export const apiDocsPageEntry = {
  title: 'API docs',
  path: '/admin/api-docs',
  description:
    "Open the backend's Swagger docs for the Messenger and partner APIs, signed in as you.",
} as const
